import { QuestionPath } from "../helpers/config-data-parser";

export const gridDataFilterQueryStringKey = 'grid-data-filter';

export class DASHBOARD_FILTER_NAMES {

  static readonly maatUsers = 'maatUsers';

  static readonly maatSorDescriptions = 'maatSorDescriptions';

  static readonly maatAuditPlans = 'maatAuditPlans';

  static readonly maatJobsByAuditPlan = (maatAuditPlanId: string) => `maatJobsByAuditPlan-${maatAuditPlanId}`;
  static readonly maatJobItemsByAuditPlan = (maatAuditPlanId: string) => `maatJobItemsByAuditPlan-${maatAuditPlanId}`;
  static readonly maatNcqsByAuditPlan = (maatAuditPlanId: string) => `maatNcqsByAuditPlan-${maatAuditPlanId}`;

  static readonly maatJobItemsByJob = (maatJobId: string) => `maatJobItemsByJob-${maatJobId}`;
  static readonly maatNcqsByJob = (maatJobId: string) => `maatNcqsByJob-${maatJobId}`;
  static readonly maatPropertyHistoriesByJob = (maatJobId: string) => `maatPropertyHistoriesByJob-${maatJobId}`;

  static readonly maatNcqsByJobItem = (maatJobItemId: string) => `maatNcqsByJobItem-${maatJobItemId}`;
}

export type GridDataFilterSettings<TFilterRequest> = {

  // Function to get the email address of the currently logged-in user (it is used as a unique key when setting/getting the filter model into/from session storage)
  getLoggedInUserEmail: () => string;

  // Function to get the name of the filter (it is used as a unique key when setting/getting the filter model into/from session storage)
  getFilterName: () => string;

  // Path to the question that contains the "search" question model (a falsy value indicates that there is no "search" question)
  searchQuestionPath: QuestionPath;

  // Path to the question that contains the "filter" question model (a falsy value indicates that there is no "filter" question)
  filterQuestionPath: QuestionPath;

  // Function to get the filter request from the "search" and "filter" question models
  getFilterRequestFromModels: (searchQuestionModel: any, filterQuestionModel: any) => TFilterRequest;

  // Function to get the default filter request
  getDefaultFilterRequest: () => TFilterRequest;
};
